<template>
  <div class="mb-1 mb-sm-2">
    <h3 class="mb-1 mb-sm-2">
      {{ $t("signup.contract_review_component.data_review_title") }}
    </h3>
    <p>
      {{ $t("signup.contract_review_component.data_review_subtext") }}
    </p>

    <!-- Signatory data card -->
    <div class="card p-3 mb-3">
      <h5 class="mb-1 mb-sm-2">
        {{ $t("signup.contract_review_component.data_signer_title") }}
      </h5>
      <div v-for="field in signerFields" :key="field.label">
        <div class="row g-2 py-1">
          <label class="col-sm-3 col-form-label fw-bold py-0">{{
            field.label
          }}</label>
          <div class="col-sm-8 col-10 py-0">{{ field.value || "-" }}</div>
        </div>
      </div>
    </div>

    <!-- Company data card -->
    <div class="card p-3 mb-3">
      <h5 class="mb-1 mb-sm-2">
        {{ $t("signup.contract_review_component.data_company_title") }}
      </h5>
      <div v-for="field in companyFields" :key="field.label">
        <div class="row g-2 py-1">
          <label class="col-sm-3 col-form-label fw-bold py-0">{{
            field.label
          }}</label>
          <div class="col-sm-8 col-10 py-0">{{ field.value || "-" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface DisplayField {
  label: string;
  value: string | undefined | null;
}

defineProps<{
  signerFields: DisplayField[];
  companyFields: DisplayField[];
}>();
</script>
